var _rect, _g, _rect2, _rect3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 20,
    fill: "#FFDAC4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5562_163509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5191 30.8594H20.7818C19.1992 30.8613 17.682 31.4908 16.563 32.6099C15.4439 33.7289 14.8144 35.2461 14.8125 36.8287V42.9015H36.4884V36.8287C36.4865 35.2461 35.8569 33.7289 34.7379 32.6099C33.6188 31.4908 32.1016 30.8613 30.5191 30.8594V30.8594Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.65 27.2453C28.9753 27.2453 31.6711 24.5495 31.6711 21.2242C31.6711 17.8989 28.9753 15.2031 25.65 15.2031C22.3246 15.2031 19.6289 17.8989 19.6289 21.2242C19.6289 24.5495 22.3246 27.2453 25.65 27.2453Z",
    fill: "#FE9452"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9062,
    y: 27.7227,
    width: 11.4711,
    height: 11.4711,
    rx: 5.73556,
    fill: "#FD6202"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9062,
    y: 27.7227,
    width: 11.4711,
    height: 11.4711,
    rx: 5.73556,
    stroke: "#FFDAC4",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0473 32.8627L34.0781 32.8627L34.0781 34.0504L37.0473 34.0504L37.0473 37.0195L38.235 37.0195L38.235 34.0504L41.2041 34.0504L41.2041 32.8627L38.235 32.8627L38.235 29.8935L37.0473 29.8935L37.0473 32.8627Z",
    fill: "#FFDAC4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5562_163509"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.1992,
    y: 14,
    width: 28.9011,
    height: 28.9011,
    rx: 14.4506,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomers);
export default __webpack_public_path__ + "static/media/newCustomers.821fbfe3e07b64036a2645669c838134.svg";
export { ForwardRef as ReactComponent };